import './patient-list-item.scss';

import { kebabCase } from 'lodash';
import { useMemo } from 'react';

import { PatientItemDataFragment } from '../../../data/types/api/graphql';
import { useFormatters } from '../../../data/utils/formatters.utils';
import { makeKeyDownHandler } from '../../../data/utils/make-key-down-handler';
import { Tag, TagType } from '../../../elements/tag/tag';

type PatientListItemProps = {
  patientItem: PatientItemDataFragment;
  onClick?: (value: PatientItemDataFragment) => void;
};

export function PatientListItem({
  patientItem,
  onClick,
}: PatientListItemProps) {
  const attributes = useMemo(() => {
    if (onClick) {
      return {
        role: 'button',
        tabIndex: 0,
        onClick: () => onClick(patientItem),
        onKeyDown: makeKeyDownHandler(() => onClick(patientItem)),
      };
    }

    return {};
  }, [patientItem, onClick]);

  const { getFullName, getBirthDate } = useFormatters();

  return (
    <div
      {...attributes}
      className={`patient-list-item patient-list-item--${kebabCase(
        patientItem.status
      )}`}
    >
      <div className="patient-list-item__content">
        <h3>{getFullName(patientItem)}</h3>
        <p>{getBirthDate(patientItem)}</p>
      </div>
      <div className="patient-list-item__tags">
        {!patientItem.dutchInsurance && <Tag type={TagType.NOINSURANCE} />}
        {patientItem.noShowProtocol && <Tag type={TagType.NOSHOWPROTOCOL} />}

        <Tag type={patientItem.status} />
      </div>
    </div>
  );
}
